import React, { useState } from 'react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Esto es una dieta?',
    a: 'No. Es una guía educativa con herramientas prácticas. No prescribe dietas ni elimina grupos de alimentos.'
  }, {
    q: '¿Tengo que dejar el azúcar al 100%?',
    a: 'No. El objetivo es reducir el impacto del azúcar oculto, no vivir en restricción. Se trata de decisiones informadas.'
  }, {
    q: '¿Funciona si no cocino o como fuera?',
    a: 'Sí. El decodificador de etiquetas y el orden de los alimentos se aplican en restaurantes, comida a domicilio o el supermercado.'
  }, {
    q: '¿En cuánto tiempo se nota?',
    a: 'El plan está estructurado en 14 días. Puedes ir a tu ritmo. Resultados individuales varían.'
  }, {
    q: '¿Y si ya intenté antes?',
    a: 'Este sistema no te pide dejarlo de golpe. Te enseña a identificarlo, entender su impacto y decidir mejor, paso a paso.'
  }, {
    q: '¿Cómo lo recibo?',
    a: 'Por email, inmediatamente después de la compra. Recibes un enlace para descargar los 4 archivos PDF.'
  }, {
    q: '¿Qué pasa si no me llega el email?',
    a: 'Revisa spam o promociones. Si no lo encuentras, escríbenos a soporte y te lo reenviamos de inmediato.'
  }, {
    q: '¿Es consejo médico?',
    a: 'No. Es contenido estrictamente educativo. No es diagnóstico ni reemplaza la atención de un profesional de salud.'
  }];
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" className="py-16 md:py-24 px-4 bg-cream" data-id="element-196">
      <div className="max-w-3xl mx-auto" data-id="element-197">
        <div className="text-center mb-12" data-id="element-198">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy leading-tight" data-id="element-199">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4 mb-12" data-id="element-200">
          {faqs.map((faq, idx) => {
          const isOpen = openIndex === idx;
          return <div key={idx} className="bg-white border border-navy/5 rounded-xl overflow-hidden shadow-sm transition-all duration-200" data-id="element-201">
                <button onClick={() => toggleFaq(idx)} className="w-full flex items-center justify-between gap-4 p-6 text-left cursor-pointer hover:bg-cream-dark/30 transition-colors" data-id="element-202">
                  <h3 className="text-lg font-bold text-navy font-sans pr-8" data-id="element-203">
                    {faq.q}
                  </h3>
                  <span className={`text-navy/40 font-bold text-xl transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} data-id="element-204">
                    +
                  </span>
                </button>
                <div className={`grid transition-all duration-300 ease-in-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-205">
                  <div className="overflow-hidden" data-id="element-206">
                    <p className="text-navy/70 font-sans leading-relaxed px-6 pb-6 pt-2" data-id="element-207">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>

        <div className="flex flex-col items-center gap-3" data-id="element-208">
          <a href="https://www.godeskcore.com/cart/42794527916080:1" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto" data-id="element-209">
            <button className="w-full md:w-auto bg-cta hover:bg-cta-hover text-white font-bold text-base md:text-lg py-4 px-8 rounded-lg transition-all duration-300 shadow-[0_4px_14px_0_rgba(200,16,46,0.39)] hover:shadow-[0_6px_20px_rgba(200,16,46,0.23)] hover:-translate-y-0.5 flex items-center justify-center gap-2" data-id="element-210">
              <span data-id="element-211">🔒 DESCARGAR EBOOK + 3 BONOS — $17.95</span>
            </button>
          </a>
          <p className="text-xs md:text-sm text-navy/60 font-sans text-center" data-id="element-212">
            Acceso inmediato · 4 PDFs descargables · Tuyos para siempre · Pago
            seguro
          </p>
        </div>
      </div>
    </section>;
}